import React, { ReactNode, VFC } from 'react';
import styled from 'styled-components';
import { SERVICE_COLOR } from '../../../../core/styles/variables';

interface Props {
  subtitle?: ReactNode;
  children: ReactNode;
}
const CardsLineTitle: VFC<Props> = ({ subtitle, children }: Props) => {
  return (
    <Wrapper>
      <Title>{children}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Wrapper>
  );
};

export default CardsLineTitle;

const Wrapper = styled.h4`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
`;
const Title = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
`;
const Subtitle = styled.span`
  font-size: 12px;
  color: ${SERVICE_COLOR};
`;
